<template>
  <div class="mx-5">
    <v-card tile flat>
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" md="2" sm="12" class="pa-5 blue darken-2 text-center">
            <v-icon dark size="80">mdi-alert</v-icon>
          </v-col>
          <v-col cols="12" md="10" sm="12" class="pa-5 blue darken-1 white--text">
            <h1 class="headline"> <strong>Instruksi</strong> Pemeriksaan Esai</h1>
            Baca esai yang sudah ditulis oleh kandidat, lalu berikan nilai sesuai dengan rubrik yang tersedia, Jika anda
            kebingungan mengenai penilaian,
            <u @click="onPanduan" style="cursor: pointer"><b>Silahkan Masuk ke Panduan Penilaian</b></u>
            <v-row class="mt-2" dense>
              <v-col cols="12" md="5">
                <v-list
                  dense
                  two-line
                  outlined
                  :class="`pt-0 yellow`"
                  :style="{ marginTop: '0px', borderRadius: '5px' }"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon class="mt-3" color="indigo" size="40">mdi-account-star</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="ml-n2 indigo--text">
                      <p>{{ infoAsesor.nama }}</p>
                      <h3>
                        {{ infoAsesor.email }}
                      </h3>
                      <h4>
                        {{ infoAsesor.no_hp }}
                        <v-icon v-if="infoAsesor.no_hp" color="success" small dark @click="onCall(infoAsesor.no_hp)">
                          mdi-whatsapp
                        </v-icon>
                      </h4>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto container">
      <v-toolbar flat>
        <v-toolbar-title>
          <div class="headline">
            Data Esai
            <span class="blue--text">Kandidat {{ $getDeepObj(detail, 'id') }}</span>
          </div>
        </v-toolbar-title>
        <v-spacer />
        <template v-if="isPreview">
          <v-chip dark :color="$getDeepObj(detail, 'k_proses_nilai_esai_psp') === 3 ? 'success' : 'error'">
            {{ $getDeepObj(detail, 'k_proses_nilai_esai_psp') === 3 ? 'Sudah Dinilai' : 'Belum Dinilai' }}
          </v-chip>
        </template>
        <v-btn
          v-if="
            [3].includes(Number($getDeepObj(detail, 'gelombang'))) && type === 'kasek'
              ? $allow('psp-peserta-esai.print')
              : $allow('psp-pelatih-ahli-esai.print')
          "
          class="mx-1"
          depressed
          small
          color="blue"
          dark
          @click="onCetakEsai"
          ><v-icon left>mdi-printer</v-icon> Cetak Esai</v-btn
        >
      </v-toolbar>
      <v-divider></v-divider>
      <!--pertanyaan-->
      <v-expansion-panels accordion class="mt-5 elevation-0" v-model="showEsai">
        <v-expansion-panel v-for="(pertanyaan, i) in pertanyaans" :key="i">
          <v-expansion-panel-header :id="`panels-id-${i + 1}`">
            <span class="indigo--text darken-4--text subtitle-1 font-weight-medium">
              {{ pertanyaan.title }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-2">
            <v-card outlined class="pa-0">
              <v-card-text class="pa-0">
                <v-expansion-panels accordion class="mt-2" flat>
                  <v-expansion-panel v-for="(sub, j) in getEsai(i + 1)" :key="sub.id">
                    <v-expansion-panel-header>
                      <v-row no-gutters dense class="black--text subtitle-1 font-weight-medium">
                        <v-col cols="1">
                          <div>{{ $getDeepObj(sub, 'kode') }}.</div>
                        </v-col>
                        <v-col cols="11" class="ml-md-n10">
                          {{ $getDeepObj(sub, 'pertanyaan') }}
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row no-gutters>
                        <v-col cols="12" md="1" sm="1"> &nbsp; </v-col>
                        <v-col cols="12" md="11" sm="11" class="ml-md-n10">
                          <span
                            v-html="
                              $stringToHtml(
                                $getDeepObj(resultEsai, `${sub.k_profil_esai_psp}.deskripsi`) || 'Belum di jawab'
                              )
                            "
                          ></span>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    <v-divider v-if="getEsai(i + 1).length - 1 < j"></v-divider>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!--rubrik-->
      <v-row class="px-0 py-5">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title class="display-1">Rubrik Penilaian</v-toolbar-title>
            <v-spacer />
            <v-btn color="blue" dark @click="onPanduan">
              <v-icon left>mdi-alert-circle</v-icon>
              PANDUAN PENILAIAN
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card v-for="item in rubriks" outlined class="mt-3" :key="item.key">
        <v-row>
          <v-col cols="12" md="6">
            <div class="pa-3">
              <div class="blue--text body-1">
                <strong>{{ item.title }}</strong>
                <v-spacer></v-spacer>
                <a href="javascript:" @click="onShowEsai(Number(item.refEsai))">(Esai No. {{ item.refEsai }})</a>
              </div>
              <div class="black--text my-2">
                {{ item.label }}
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="pa-3">
              <div><strong>Penilaian</strong></div>
              Berapa total kriteria yang terpenuhi berdasarkan jawaban kandidat ini?
            </div>
            <div class="pa-3">
              <div class="radio-outline">
                <template v-for="skor in item.skoring">
                  <span class="ml-md-1" :key="skor">
                    <input
                      :disabled="isPreview ? isPreview : isDisable"
                      type="radio"
                      :id="`${item.key}_${skor}`"
                      v-model="form[item.id]"
                      :value="`${skor}`"
                      checked
                    />
                    <label :for="`${item.key}_${skor}`">{{ !skor ? 'NA' : skor }}</label>
                  </span>
                </template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-2"
                      color="info"
                      @click="onPanduanRubrik(item.key, item.title, item.label)"
                      v-on="on"
                    >
                      mdi-help-circle
                    </v-icon>
                  </template>
                  <span>PANDUAN PENILAIAN</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card outlined class="mt-3">
        <v-row>
          <v-col cols="12">
            <div class="pa-3 pb-0">
              <strong>Catatan Penilaian</strong>
            </div>
            <div class="pa-3 pt-0">
              <v-textarea
                v-model="form.catatan"
                class="mt-0"
                hide-details
                rows="3"
                auto-grow
                :placeholder="`${!isPreview ? 'Tuliskan catatan hasil penilaian esai kandidat apabila ada' : ''}`"
                :readonly="isPreview ? isPreview : isDisable"
              ></v-textarea>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
    <panduan-esai ref="panduan" :min="1" />
  </div>
</template>

<script>
import configs from '../esai/configs.js';
import configsKasek from '@views/gtk/esai/configs/kasek';
import configsInstruktur from '@views/gtk/esai/configs/instruktur.js';
export default {
  name: 'FormEsai',
  props: {
    initValue: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    angkatan: {
      type: Number,
      default: 1,
    },
    esais: {
      type: Array,
      default: () => [],
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PanduanEsai: () => import('../component/PanduanEsai'),
  },
  data() {
    return {
      form: {},
      showEsai: 0,
      configsEsai: {
        kasek: configsKasek,
        instruktur: configsInstruktur,
      },
    };
  },

  computed: {
    resultEsai() {
      const esai = this.$arrToObj(this.esais, 'k_profil_esai_psp');
      return esai;
    },

    rubriks() {
      const model = configs.rubriks[this.type] || [];
      return model[this.angkatan];
    },

    kategoriNilai() {
      return {
        1: { text: 'Kategori A', color: 'success' },
        2: { text: 'Kategori B', color: 'orange' },
        3: { text: 'Kategori C', color: 'red' },
      };
    },

    infoAsesor() {
      const proses = this.$getDeepObj(this.detail, 'psp_profil_proseses.data') || [];
      const kProsesNilai = this.$getDeepObj(this.detail, 'k_proses_nilai_esai_psp') === 3 ? 11 : 10;
      const data = proses.filter((item) => item.k_profil_proses_psp === kProsesNilai)[0];
      return this.$getDeepObj(data, 'akun.data') || {};
    },

    pertanyaans() {
      const model = this.configsEsai[this.type] || [];
      const pertanyaan = (model && model['header'] && model['header'][this.angkatan]) || [];
      return pertanyaan;
    },
  },

  methods: {
    reset() {
      this.showEsai = 0;
      this.$set(this, 'form', {});
    },

    initForm(value) {
      if (value && value.length) {
        for (const item of value) {
          this.$set(
            this.form,
            item['k_profil_rubrik_psp'],
            ([null, '', undefined].includes(item['nilai']) ? '' : item['nilai']).toString()
          );
        }
      }

      const proses = this.$getDeepObj(this.detail, 'psp_profil_proseses.data') || [];
      const data = proses.filter((item) => item.k_profil_proses_psp === 11)[0];
      const catatan = this.$getDeepObj(data, 'catatan') || '';
      this.$set(this.form, 'catatan', catatan);
    },

    getEsai(nomor) {
      const pertanyaan = this.$getDeepObj(this.detail, 'meta.pertanyaans') || [];
      const esai = pertanyaan.filter((item) => {
        return item.nomor === nomor;
      });
      return esai;
    },

    onShowEsai(number) {
      this.showEsai = number - 1;
      document.getElementsByClassName('v-dialog--active')[0].scrollTop = 250;
    },

    onPanduan() {
      this.$refs.panduan.open('guru');
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(item)}`;
      window.open(url, '_blank');
    },

    onPanduanRubrik(id, label, desc) {
      const model = this.$getDeepObj(configs.panduan, `${this.type}.${this.angkatan}`);
      let panduan = {};
      Object.keys(model[id]).forEach((index) => {
        this.$set(panduan, index === 'NA' ? 'NA' : index - 1, model[id][index]);
      });

      const data = {
        label: label,
        desc: desc,
        esais: panduan,
      };

      this.$refs.panduan.open('rubriks', data);
    },

    onCetakEsai() {
      this.$store.dispatch('penilaian/cetakEsai', { id: this.$getDeepObj(this.detail, 'id') }).then((url) => {
        window.open(url);
      });
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
